import { render, staticRenderFns } from "./BlogSocialNetworks.vue?vue&type=template&id=53607cd0&lang=pug&"
import script from "./BlogSocialNetworks.vue?vue&type=script&lang=js&"
export * from "./BlogSocialNetworks.vue?vue&type=script&lang=js&"
import style0 from "./BlogSocialNetworks.vue?vue&type=style&index=0&id=53607cd0&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports